"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _base_user_input_store = _interopRequireWildcard(require("./base_user_input_store"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var QUIET_NATIVE_RESET_REASONS = new Set(['cleanupOffscreen', 'softReset', 'onReset', 'dispose']);
var shortId = function shortId(value) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  return typeof value === 'string' ? value.substring(0, length) : value;
};
var shortUri = function shortUri(uri) {
  return {
    uriExists: Boolean(uri)
  };
};
var NativeUserInputStore = (_class = /*#__PURE__*/function (_BaseUserInputStore) {
  function NativeUserInputStore() {
    var _this;
    var _params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, NativeUserInputStore);
    _this = _callSuper(this, NativeUserInputStore, [_objectSpread(_objectSpread({}, _params), {}, {
      isNative: true
    })]);
    (0, _initializerDefineProperty2["default"])(_this, "hasNativeSound", _descriptor, _this);
    (0, _initializerDefineProperty2["default"])(_this, "pendingNativePlayback", _descriptor2, _this);
    (0, _initializerDefineProperty2["default"])(_this, "nativeSoundIsLoading", _descriptor3, _this);
    (0, _initializerDefineProperty2["default"])(_this, "nativeAudioRecorder", _descriptor4, _this);
    (0, _initializerDefineProperty2["default"])(_this, "lastRecordingUri", _descriptor5, _this);
    (0, _initializerDefineProperty2["default"])(_this, "lastRecordingMimeType", _descriptor6, _this);
    (0, _initializerDefineProperty2["default"])(_this, "lastRecordingResult", _descriptor7, _this);
    _this._isResetting = false;
    _this.initializeAudioIfNeeded = function () {
      // Native recorders are initialized outside of the web AudioStream flow.
    };
    _this.setNativeAudioRecorder = function (nativeAudioRecorder) {
      _this.nativeAudioRecorder = nativeAudioRecorder;
    };
    _this.dispose = function () {
      if (_this.nativeAudioRecorder && _this.cardId && _this.isRecording) {
        _this.nativeAudioRecorder.stopRecording(_this.cardId);
      }
      _this.resetNativeRecorder('dispose');
      _this.stopSecondsElapsed();
      if (_this.recorder) {
        _this.recorder = null;
      }
    };
    _this.resetNativeRecorder = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var reason,
        shouldLogReset,
        result,
        _args = arguments,
        _t;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            reason = _args.length > 0 && _args[0] !== undefined ? _args[0] : 'softReset';
            if (!(!_this.nativeAudioRecorder || typeof _this.nativeAudioRecorder.resetIfOwned !== 'function')) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            shouldLogReset = _this.logger && !QUIET_NATIVE_RESET_REASONS.has(reason);
            if (shouldLogReset) {
              _this.logger.log('resetNativeRecorder invoked', {
                reason: reason,
                cardId: shortId(_this.cardId)
              });
            }
            _context.prev = 2;
            _context.next = 3;
            return _this.nativeAudioRecorder.resetIfOwned(_this.cardId, {
              reason: reason
            });
          case 3:
            result = _context.sent;
            if (result && typeof result["catch"] === 'function') {
              // If the result is a promise (it should be), we've already awaited it above,
              // but if it returns a promise that rejects later or if we didn't await it correctly, catch here.
              // However, since we added await, we should rely on the try/catch block.
            }
            _context.next = 5;
            break;
          case 4:
            _context.prev = 4;
            _t = _context["catch"](2);
            if (_this.logger) {
              _this.logger.log('resetNativeRecorder threw', {
                reason: reason,
                cardId: shortId(_this.cardId),
                error: _t
              });
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 4]]);
    }));
    _this.onAudioLevelUpdate = function (audioLevel) {
      _this.audioLevel = audioLevel;
      if (_this.normalizedAudioLevel > _this.maxAudioLevel) {
        _this.maxAudioLevel = _this.normalizedAudioLevel;
      }
    };
    _this.startRecording = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var options,
        _args2 = arguments,
        _t2;
      return _regenerator["default"].wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
            if (!(!_this.nativeAudioRecorder || !_this.cardId)) {
              _context2.next = 1;
              break;
            }
            return _context2.abrupt("return");
          case 1:
            if (_this.isCurrentCard()) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            if (_this.nativeAudioRecorder.canRecord(_this.cardId)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            _this.hasNativeSound = false;
            _this.nativeSoundIsLoading = false;
            _context2.prev = 4;
            _this.nativeSoundIsLoading = true;
            _context2.next = 5;
            return _this.nativeAudioRecorder.startRecording({
              callback: _this.updateScreenForRecordingStatus,
              audioPlaybackFinishedCallback: _this.audioPlaybackFinishedCallback,
              cardId: _this.cardId,
              attemptContext: options.attemptContext
            });
          case 5:
            _this.nativeSoundIsLoading = false;
            _this.startSecondsElapsed();
            _this.isRecording = true;
            _this.hasFinishedRecording = false;
            if (_this.logger) {
              _this.logger.log('Native recording start succeeded; isRecording=true', {
                cardId: shortId(_this.cardId)
              });
            }
            _context2.next = 7;
            break;
          case 6:
            _context2.prev = 6;
            _t2 = _context2["catch"](4);
            if (_this.logger) {
              _this.logger.log('Native recording start failed', {
                cardId: shortId(_this.cardId),
                error: _t2
              });
            }
            _this.handleNativeRecordingStartFailure();
            throw _t2;
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4, 6]]);
    }));
    _this.handleNativeRecordingStartFailure = function () {
      _this.isRecording = false;
      _this.hasFinishedRecording = false;
      _this.nativeSoundIsLoading = false;
      _this.pendingNativePlayback = false;
      _this.startRecordingTimestamp = null;
      _this.endRecordingTimestamp = null;
      _this.secondsElapsed = 0;
      _this.audioLevel = 0;
      _this.maxAudioLevel = 0;
      if (_this.interval) {
        clearInterval(_this.interval);
        _this.interval = null;
      }
      if (_this.nativeAudioRecorder && _this.cardId) {
        _this.nativeAudioRecorder.clearRecording();
      }
    };
    _this.stopRecording = function () {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (Object.prototype.hasOwnProperty.call(params, 'autoPlay')) {
        _this.autoPlay = params.autoPlay;
      }
      if (!_this.isRecording) {
        return;
      }
      _this.stopSecondsElapsed();
      _this.audioLevel = 0;
      _this.endRecordingTimestamp = +new Date();
      _this.isRecording = false;
      _this.hasFinishedRecording = true;
      if (!params.skipCallback) {
        _this.nativeSoundIsLoading = true;
      }
      if (_this.nativeAudioRecorder) {
        _this.nativeAudioRecorder.stopRecording({
          callback: params.skipCallback ? undefined : _this.updateScreenForSoundStatus,
          cardId: _this.cardId
        });
      }
    };
    _this.updateScreenForRecordingStatus = function (status) {
      _this.canRecord = status.canRecord;
      if (status.metering) {
        var linearAudioLevel = Math.pow(10, status.metering / 20) * 160;
        _this.onAudioLevelUpdate(linearAudioLevel / _base_user_input_store.LEVEL_MULTIPLIER);
      }
      if ((status.isDoneRecording || status.isRecording) && status.durationMillis) {
        _this.durationFromDatabase = Math.round(status.durationMillis / 1000 * 10) / 10;
      }
    };
    _this.updateScreenForSoundStatus = function (status) {
      if (_this.logger && status) {
        if (status.hasError || status.error) {
          _this.logger.warn('Recording error reported', {
            cardId: shortId(_this.cardId),
            error: status.error
          });
        } else if (status.playbackFailureReason) {
          _this.logger.warn('Recording playback not ready', _objectSpread({
            cardId: shortId(_this.cardId),
            reason: status.playbackFailureReason
          }, shortUri(status.uri || null)));
        } else if (status.isReadyForPlayback) {
          var _status$durationMilli;
          _this.logger.log('Recording ready for playback', _objectSpread({
            cardId: shortId(_this.cardId),
            durationMillis: (_status$durationMilli = status.durationMillis) !== null && _status$durationMilli !== void 0 ? _status$durationMilli : null
          }, shortUri(status.uri || null)));
        }
      }
      _this.lastRecordingResult = status || null;
      if (status && status.uri) {
        _this.lastRecordingUri = status.uri;
      }
      if (status && status.mimeType) {
        _this.lastRecordingMimeType = status.mimeType;
      }
      var readyForPlayback = Boolean(status.isReadyForPlayback);
      var hasDuration = typeof status.durationMillis === 'number' && status.durationMillis > 0;
      if (_this.playing && status.didJustFinish) {
        _this.audioPlaybackFinishedCallback();
      }
      if (readyForPlayback && hasDuration) {
        _this.hasNativeSound = true;
        _this.nativeSoundIsLoading = false;
        _this.durationFromDatabase = Math.round(status.durationMillis / 1000 * 10) / 10;
        if (_this.autoPlay || _this.pendingNativePlayback) {
          _this.play();
        }
      } else if (status.loadFailed || status.playbackFailureReason) {
        _this.nativeSoundIsLoading = false;
        _this.hasNativeSound = false;
        _this.pendingNativePlayback = false;
      }
    };
    _this.isCurrentCard = function () {
      return Boolean(_this.parent && _this.parent.currentCard && _this.parent.currentCard.id === _this.cardId);
    };
    _this.play = function () {
      if (!_this.nativeAudioRecorder) {
        if (_this.logger) {
          _this.logger.warn('Cannot play - nativeAudioRecorder missing');
        }
        _this.pendingNativePlayback = false;
        return;
      }
      if (!_this.isCurrentCard()) {
        _this.autoPlay = false;
        _this.pendingNativePlayback = false;
        _this.playing = false;
        _this.startPlayingTimestamp = null;
        return;
      }
      _this.playing = true;
      _this.startPlayingTimestamp = +new Date();
      if (_this.hasNativeSound) {
        _this.pendingNativePlayback = false;
        try {
          var result = _this.nativeAudioRecorder.play(_this.cardId);
          if (result && typeof result.then === 'function') {
            result.then(function (ok) {
              if (ok === false || !_this.playing || !_this.isCurrentCard()) {
                _this.playing = false;
                _this.startPlayingTimestamp = null;
                if (ok !== false) {
                  _this.pauseNativePlayback();
                }
              }
            })["catch"](function (error) {
              if (_this.logger) {
                _this.logger.error('Error in nativeAudioRecorder.play()', error);
              }
              if (_this.playing) {
                _this.playing = false;
                _this.startPlayingTimestamp = null;
              }
            });
          }
        } catch (error) {
          if (_this.logger) {
            _this.logger.error('Error calling nativeAudioRecorder.play()', error);
          }
          _this.playing = false;
          _this.startPlayingTimestamp = null;
        }
      } else {
        _this.playing = false;
        _this.startPlayingTimestamp = null;
        _this.pendingNativePlayback = true;
      }
    };
    _this.pauseNativePlayback = function () {
      if (!_this.nativeAudioRecorder) {
        return;
      }
      try {
        _this.nativeAudioRecorder.pause();
      } catch (error) {
        if (_this.logger) {
          _this.logger.error('Error calling nativeAudioRecorder.pause()', error);
        }
      }
    };
    _this.pause = function () {
      _this.autoPlay = false;
      _this.pendingNativePlayback = false;
      _this.pauseNativePlayback();
      if (!_this.playing) {
        return;
      }
      _this.playing = false;
      _this.pausePlayingTimestamp = +new Date();
      if (_this.interval) {
        clearInterval(_this.interval);
        _this.interval = null;
      }
    };
    _this.onSoftReset = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var _this$nativeAudioReco;
      var reason,
        _args3 = arguments;
      return _regenerator["default"].wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            reason = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 'softReset';
            _this.isRecordingStartPending = false;
            _this._activeStartRecordingTaskId = null;
            _context3.next = 1;
            return _this.resetNativeRecorder(reason);
          case 1:
            _this.resetRecordingState();
            _this.hasNativeSound = false;
            _this.pendingNativePlayback = false;
            _this.nativeSoundIsLoading = false;
            _this.durationFromDatabase = null;
            // Clean up the recording file to prevent accumulation
            if (_this.lastRecordingUri && (_this$nativeAudioReco = _this.nativeAudioRecorder) !== null && _this$nativeAudioReco !== void 0 && _this$nativeAudioReco.deleteRecordingFile) {
              _this.nativeAudioRecorder.deleteRecordingFile(_this.lastRecordingUri)["catch"](function () {
                // Ignore deletion errors - file may already be gone
              });
            }
            _this.lastRecordingUri = null;
            _this.lastRecordingResult = null;
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    _this.onReset = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      return _regenerator["default"].wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!_this._isResetting) {
              _context4.next = 1;
              break;
            }
            if (_this.logger) {
              _this.logger.warn('onReset already in progress, ignoring duplicate request');
            }
            return _context4.abrupt("return");
          case 1:
            _this._isResetting = true;
            _context4.prev = 2;
            if (_this.nativeAudioRecorder && _this.cardId && _this.isRecording) {
              _this.nativeAudioRecorder.stopRecording(_this.cardId);
            }
            _this.pause();
            _this.playing = false;
            _this.currentTime = 0;
            _this.initialPlayHasFinished = false;
            _context4.next = 3;
            return _this.onSoftReset('onReset');
          case 3:
            _context4.prev = 3;
            setTimeout(function () {
              _this._isResetting = false;
            }, 10);
            return _context4.finish(3);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[2,, 3, 4]]);
    }));
    _this.cleanupOffscreen = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      return _regenerator["default"].wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _this.pause();
            // Note: We intentionally do NOT call stopRecording() here.
            // stopRecording() triggers playback player creation which is async and can race with onSoftReset.
            // onSoftReset() will trigger the native recorder reset which stops recording cleanly.
            _context5.next = 1;
            return _this.onSoftReset('cleanupOffscreen');
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    _this.onMediaReset = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
      return _regenerator["default"].wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _this.pause();
            _context6.next = 1;
            return _this.onSoftReset('mediaReset');
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    _this.resetForNewRecording = function () {
      _this.cleanupOffscreen();
    };
    _this.onDeviceDeniedAccess = function () {
      if (_this.parent) {
        _this.parent.set('deviceDeniedAccess', true);
      }
    };
    _this.getFormData = function () {
      if (!_this.lastRecordingUri) {
        return null;
      }
      var formData = new FormData();
      formData.append('blob', {
        uri: _this.lastRecordingUri,
        type: _this.lastRecordingMimeType || 'audio/m4a',
        name: "recording-".concat(_this.cardId || 'native', ".m4a")
      });
      return formData;
    };
    _this.mediaType = 'audio';
    _this.setupNativeLogger();
    return _this;
  }
  (0, _inherits2["default"])(NativeUserInputStore, _BaseUserInputStore);
  return (0, _createClass2["default"])(NativeUserInputStore, [{
    key: "setupNativeLogger",
    value: function setupNativeLogger() {
      try {
        var logger = require('../../../mobile/utils/logger')["default"];
        this.logger = logger.createScoped('NativeUserInputStore');
        var _require = require('@seedlang/state'),
          AppUI = _require.AppUI;
        this.AppUI = AppUI;
      } catch (error) {
        this.logger = null;
        this.AppUI = null;
      }
    }
  }, {
    key: "hasRecording",
    get: function get() {
      return this.hasNativeSound;
    }
  }]);
}(_base_user_input_store["default"]), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasNativeSound", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "pendingNativePlayback", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "nativeSoundIsLoading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "nativeAudioRecorder", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "lastRecordingUri", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "lastRecordingMimeType", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'audio/m4a';
  }
}), _descriptor7 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "lastRecordingResult", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasRecording", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasRecording"), _class.prototype), _class);
var _default = exports["default"] = NativeUserInputStore;